"use client";

import { CountDownTimer } from "./Timer";
import { RESENDT_OTP_DELAY_DURATION_IN_SECONDS } from "../../constants/LoginConstants";
import { requestOtp, verifyOtp } from "../../services/auth";
import { handleLogin } from "../../actions/LoginActon";
import { Button, Form, Input, Typography, Card, Image } from "antd";
import { useState } from "react";
import logo from "../../Images/DoorWashLogo.svg";

const { Text } = Typography;

export const LoginForm = () => {
  const [otpRequested, setOtpRequested] = useState(false);
  const [resendOtpTimerOn, setResendOtpTimerOn] = useState(false);
  const [sendingRequest, setSendingRequest] = useState(false);
  const [form] = Form.useForm();

  const generateOtp = (values) => {
    setSendingRequest(true);
    requestOtp(`+91${values.phone_number}`)
      .then(() => {
        setSendingRequest(false);
        setOtpRequested(true);
        setResendOtpTimerOn(true);
      })
      .catch(() => {
        setSendingRequest(false);
      });
  };

  const login = (values) => {
    setSendingRequest(true);
    verifyOtp(`+91${values.phone_number}`, `${values.otp}`)
      .then((data) => {
        setSendingRequest(false);
        handleLogin(data.token);
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "AUTH_TOKEN",
            token: data.token,
          })
        );
      })
      .catch(() => {
        setSendingRequest(false);
      });
  };

  const cancelResendOtpTimer = () => {
    setResendOtpTimerOn(false);
  };

  const setToUseDifferentNumberForOTP = () => {
    setSendingRequest(false); // remove this
    cancelResendOtpTimer();
    setOtpRequested(false);
  };

  const resendOtp = () => {
    setSendingRequest(true);
    requestOtp(`+91${form.getFieldValue("phone_number")}`)
      .then(() => {
        setSendingRequest(false);
        setResendOtpTimerOn(true);
      })
      .catch(() => {
        setSendingRequest(false);
      });
  };

  return (
    <div className="flex flex-col max-w-md mx-auto min-h-screen bg-gray-50">
      <div className="self-center mt-10">
        <Image
          src={logo}
          alt="Description of local image"
          width="200"
          height="100"
        />
      </div>
      <div className="p-5 self-center mt-20">
        <Card className="max-w-xl" title="Login or Sign Up">
          <Form
            layout="vertical"
            className="flex flex-col items-center"
            onFinish={otpRequested ? login : generateOtp}
            form={form}
          >
            <Form.Item
              name="phone_number"
              rules={[
                { required: true, message: "Please enter your phone number!" },
                {
                  pattern: /^\d{10}$/,
                  message: "Please enter a valid phone number!",
                },
              ]}
            >
              <Input
                addonBefore="+91"
                placeholder="Phone Number"
                maxLength={10}
                disabled={otpRequested}
              />
            </Form.Item>
            {otpRequested && (
              <>
                <div className="flex">
                  <Text>Enter the OTP sent to&nbsp;</Text>
                  <Text strong>+91-{form.getFieldValue("phone_number")}</Text>
                </div>
                <Form.Item
                  name="otp"
                  rules={[{ required: true, message: "Please enter OTP!" }]}
                >
                  <Input />
                </Form.Item>
              </>
            )}
            <Form.Item>
              <Button htmlType="submit" type="primary" loading={sendingRequest}>
                {otpRequested ? "Continue" : "Get OTP"}
              </Button>
            </Form.Item>
            {otpRequested && (
              <>
                <Text type="secondary">Didn&#39;t Receive OTP?</Text>
                {resendOtpTimerOn ? (
                  <div className="flex">
                    <Text type="secondary">Resend OTP in&nbsp;</Text>
                    <CountDownTimer
                      duration={RESENDT_OTP_DELAY_DURATION_IN_SECONDS}
                      onTimerEnd={cancelResendOtpTimer}
                      startTimer={resendOtpTimerOn}
                    />
                  </div>
                ) : (
                  <Button type="link" onClick={resendOtp}>
                    Resend OTP
                  </Button>
                )}
                <Button type="link" onClick={setToUseDifferentNumberForOTP}>
                  Use a different number instead.
                </Button>
              </>
            )}
          </Form>
        </Card>
      </div>
    </div>
  );
};
